import { render, staticRenderFns } from "./studio.vue?vue&type=template&id=e2990348&scoped=true"
import script from "./studio.vue?vue&type=script&lang=js"
export * from "./studio.vue?vue&type=script&lang=js"
import style0 from "./studio.vue?vue&type=style&index=0&id=e2990348&prod&lang=scss"
import style1 from "./studio.vue?vue&type=style&index=1&id=e2990348&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2990348",
  null
  
)

export default component.exports